/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './undo-button.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/components/undo-button/undo-button.component';
import * as i3 from 'ng2-json-editor/src/shared/services/json-store.service';
import * as i4 from 'ng2-json-editor/src/shared/services/dom-util.service';
const styles_UndoButtonComponent:any[] = [i0.styles];
export const RenderType_UndoButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_UndoButtonComponent,data:{}});
export function View_UndoButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'i',[['class',
      'btn fa fa-undo']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.UndoButtonComponent = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.onClick()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any)))],(null as any),(null as any));
}
export function View_UndoButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-undo-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_UndoButtonComponent_0,
      RenderType_UndoButtonComponent)),i1.ɵdid(1,49152,(null as any),0,i2.UndoButtonComponent,
      [i3.JsonStoreService,i4.DomUtilService],(null as any),(null as any))],(null as any),
      (null as any));
}
export const UndoButtonComponentNgFactory:i1.ComponentFactory<i2.UndoButtonComponent> = i1.ɵccf('re-undo-button',
    i2.UndoButtonComponent,View_UndoButtonComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3VuZG8tYnV0dG9uL3VuZG8tYnV0dG9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy91bmRvLWJ1dHRvbi91bmRvLWJ1dHRvbi5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy91bmRvLWJ1dHRvbi91bmRvLWJ1dHRvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3VuZG8tYnV0dG9uL3VuZG8tYnV0dG9uLmNvbXBvbmVudC50cy5VbmRvQnV0dG9uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGkgY2xhc3M9XCJidG4gZmEgZmEtdW5kb1wiIChjbGljayk9XCJvbkNsaWNrKClcIj48L2k+IiwiPHJlLXVuZG8tYnV0dG9uPjwvcmUtdW5kby1idXR0b24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtJQUFBO0lBQUE7SUFBMEI7TUFBQTtNQUFBO0lBQUE7SUFBMUI7RUFBQTs7O29CQ0FBO01BQUE7b0NBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/undo-button/undo-button.component.ngfactory.ts